import { useEffect, useState } from 'react';
import { isMiniApp } from './platform';
export function StaffPortalLink() {
  const [href, setHref] = useState<string>();
  useEffect(() => {
    if (isMiniApp()) return;
    const controller = new AbortController();
    void fetch('/api-config.json', { signal: controller.signal, credentials: 'omit' })
      .then((r) => (r.ok ? r.json() : null))
      .then((config) => {
        if (config?.surface === 'web' && typeof config.staffPortalUrl === 'string') {
          const u = new URL(config.staffPortalUrl);
          if (u.protocol === 'https:' && !u.username && !u.password) setHref(u.href);
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);
  return href ? (
    <a className="staff-portal-link" href={href}>
      Dành cho cán bộ ↗
    </a>
  ) : null;
}
